















import Component, { mixins } from 'vue-class-component';

import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';
import SimpleForm from '@/general/abstract/form/mixin/SimpleForm';
import { CalculationRequestFormModel } from '@/context/calculation/model/CalculationRequestFormModel';
import CalculationRequestFormTemplate
  from '@/context/calculation/components/CalculationRequestFormTemplate.vue';
import { CalculationApi } from '@/context/calculation/api/CalculationApi';
import _ from 'lodash';
import CalculationRouter from '@/context/calculation/router/CalculationRouter';

@Component({
  components: {
    CalculationRequestFormTemplate,
    FormBase
  }
})
export default class CalculationForm extends mixins<SimpleForm<CalculationRequestFormModel>>(
  SimpleForm
) {
  @VModel({ default: new CalculationRequestFormModel() }) model!: CalculationRequestFormModel;

  buildCmd(): CalculationRequestFormModel {
    if (this?.model?.id) {
      return this.model;
    }
    let command: CalculationRequestFormModel = Object.assign<
      CalculationRequestFormModel,
      CalculationRequestFormModel
    >(new CalculationRequestFormModel(), _.omit(this.model, "customer"));
    return command;
  }

  async submitApi(cmd: CalculationRequestFormModel): Promise<CalculationRequestFormModel> {
    // add datetime
    cmd.start += "T00:00:00";
    cmd.end += "T00:00:00";
    const model: CalculationRequestFormModel = cmd.id
      ? await CalculationApi.instance().update<
          CalculationRequestFormModel,
          CalculationRequestFormModel
        >(cmd)
      : await CalculationApi.instance().create<
          CalculationRequestFormModel,
          CalculationRequestFormModel
        >(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return CalculationRouter.instance().list();
  }
}
